import { Skeleton } from "@mui/material";
import { ReactElement } from "react";
import { Container as FriendsContainer } from "../FriendSelection/styles";

const loop = (times: number, callback: (i: number) => ReactElement) => {
	return [...Array(times)].map((_, i) => callback(i));
};

export const FriendSelectionSkeleton = () => {
	return (
		<FriendsContainer>
			{loop(6, (i) => (
				<Skeleton
					key={`friend-shop-friend-skeleton-${i}`}
					animation="wave"
					variant="rectangular"
					width="100%"
					height="3.81em"
					sx={{
						borderRadius: "16px",
						"@media (min-width:900px)": {
							maxWidth: "60%"
						}
					}}
				/>
			))}
		</FriendsContainer>
	);
};
